import { createActionGroup } from '@ngrx/store';

export const AnswerActions = createActionGroup({
  source: 'Answer',
  events: {},
});
